import axios from 'axios';
import {
	AbcCharacterCollectionGetQueryDto,
	AbcCharacterItemDto,
	AbcCharacterSearchQueryDto,
	AbcCharactersHandwritingSearchParamsDto,
	AbcCharactersHandwritingSearchResultDto
} from "@haohan/papi-dto";

export interface AbcCharacterSearchResponse {
	total: number,
	items: AbcCharacterItemDto[]
}

type CancelablePromise<T=unknown> = Promise<T> & {
	abort?: () => void
}

export const charactersApi = {
	search(params: AbcCharacterSearchQueryDto): CancelablePromise<AbcCharacterSearchResponse> {
		const controller = new AbortController();
		const req = axios.get<AbcCharacterSearchResponse>(
			'/api/abc/characters/search', {
				params,
				signal: controller.signal
			}
		);
		req['abort'] = controller.abort;
		return req.then(v => v.data);
	},
	async getBySymbols(params: AbcCharacterCollectionGetQueryDto) {
		const res = await axios.get<AbcCharacterItemDto[]>(
			'/api/abc/characters/getBySymbols', {params}
		);
		return res.data;
	},
	async loadCharacter(symbol: string) {
		const res = await axios.get<AbcCharacterItemDto>(
			`/api/abc/character/${symbol}`
		);
		return res.data;
	},
	async handWriting(params: AbcCharactersHandwritingSearchParamsDto) {
		const res = await axios.post<AbcCharactersHandwritingSearchResultDto>(
			'/api/abc/characters/handwriting',
			{
				...params
			}
		);
		return res.data;
	}
}